import styled from 'styled-components'

import { grayDarker, media } from '../../../utils/style-utils'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  background: ${grayDarker};
  height: 5em;

  ${media.md`
    height: 4rem;
  `}

  ${media.xs`
    height: 3rem;
  `}
`
